// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"134":"29615f24","223":"0756782e","327":"c1452764","453":"d4122674"}[chunkId] + ".chunk.js";
};